import { useSetRecoilState } from "recoil";
import { companiesAtom } from "../miscellaneous/companiesAtom";

export const useSetCompaniesState = () => {
    return useSetRecoilState(companiesAtom);
};
